import React from "react";
import styles from "./styles.module.css";

export default function Contact() {
  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <h1>Contact</h1>
        <h2>Commandes et demandes de renseignements</h2>
        <br></br>
        <div className={styles.block}>
          <span>Adresse : </span>
          <div className={styles.inline_block}>
            <span>
              Produits d'Affaires Deluxe limitée
              <br />
              330 Cranston Crescent
              <br />
              Midland, ON L4R 4V9
            </span>
          </div>
        </div>
        <div className={styles.block}>
          <span>
            Téléphone : <a href="tel:1-866-749-6327">1-866-749-6327</a> du lundi
            au vendredi, entre 8 h et 17 h30 HNE.
          </span>
        </div>
        <div className={styles.block}>
          <span>
            Télécopieur : <a href="tel:1-800-461-3325">1-800-461-3325</a> 24
            heures par jour, tous les jours.
          </span>
        </div>
        <div className={styles.block}>
          <span>
            Courriel :
            <a href="mailto:cdncustserv@nebs.com"> cdncustserv@nebs.com</a>
          </span>
        </div>
        <br></br>
        <h2>Services web</h2>
        <div className={styles.block}>
          <span>
            Téléphone : <a href="tel:1-800-463-4623">1-800-463-4623</a> du lundi
            au vendredi, entre 9 h et 17 h30 HNE.
          </span>
        </div>
        <div className={styles.block}>
          <span>
            Courriel :
            <a href="mailto:support@nebshosting.ca"> support@nebshosting.ca</a>
          </span>
        </div>
        <br></br>
        <h2>L'enregistrement d'entreprise</h2>
        <div className={styles.block}>
          <span>
            Téléphone : <a href="tel:1-866-732-4524">1-866-732-4524</a> du lundi
            au vendredi, entre 9 h et 17 h HNE.
          </span>
        </div>
        <div className={styles.block}>
          <span>
            Courriel :<a href="support@nebscorp.ca"> support@nebscorp.ca</a>
          </span>
        </div>
        <br></br>
      </div>
    </div>
  );
}
